<div class="tag" [ngClass]="color ? 'tag--' + color : null">
  <span class="tag__dot" *ngIf="showDot"></span>
  <ng-content></ng-content>
</div>
